<div *ngIf="form" [formGroup]="form" class="d-flex flex-column gap-4">
  <div class="d-flex gap-2 align-items-center">
    <app-checkbox-input
      formControlName="hasSigningAuthority"
      [controlId]="controlIdPrefix + 'hasSigningAuthority-' + index" />
    <app-form-option-label [labelFor]="controlIdPrefix + 'hasSigningAuthority-' + index" i18n
      >Has Signing Authority</app-form-option-label
    >
  </div>
  <div class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalFirstName-' + index" i18n>First Name</label>
      <app-text-input
        formControlName="firstName"
        [controlId]="controlIdPrefix + 'additionalFirstName-' + index"
        [error]="formSubmitted && form.controls.firstName.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.firstName.invalid"
        [errors]="form.controls.firstName.errors"
        [customErrorMessages]="customErrorMessages.firstName" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalLastName-' + index" i18n>Last Name</label>
      <app-text-input
        formControlName="lastName"
        [controlId]="controlIdPrefix + 'additionalLastName-' + index"
        [error]="formSubmitted && form.controls.lastName.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.lastName.invalid"
        [errors]="form.controls.lastName.errors"
        [customErrorMessages]="customErrorMessages.lastName" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalJobTitle-' + index" i18n>Job Title</label>
      <app-text-input
        formControlName="jobTitle"
        [controlId]="controlIdPrefix + 'additionalJobTitle-' + index"
        [error]="formSubmitted && form.controls.jobTitle.invalid" />
      <div class="form-input-hint" i18n>Optional</div>
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalContactTopic-' + index" i18n
        >Contact Topic</label
      >
      <app-text-input
        formControlName="contactTopic"
        [controlId]="controlIdPrefix + 'additionalContactTopic-' + index"
        [error]="formSubmitted && form.controls.contactTopic.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.contactTopic.invalid"
        [errors]="form.controls.contactTopic.errors"
        [customErrorMessages]="customErrorMessages.contactTopic" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalEmail-' + index" i18n
        >Work Email Address</label
      >
      <app-email-input
        formControlName="email"
        [controlId]="controlIdPrefix + 'additionalEmail-' + index"
        [error]="formSubmitted && form.controls.email.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.email.invalid"
        [errors]="form.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'additionalPhoneNumber-' + index" i18n
        >Primary Phone Number</label
      >
      <app-phone-country-code
        [formGroup]="form"
        [countryCodes]="countryCodeDropdowns"
        [controlId]="controlIdPrefix + 'additionalPhoneNumber-' + index"
        [phoneNumberControlName]="'phoneNumber'"
        [countryCodeControlName]="'phoneNumberCountryCode'" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.phoneNumber.invalid"
        [errors]="form.controls.phoneNumber.errors"
        [customErrorMessages]="customErrorMessages.phoneNumber" />
    </div>
  </div>

  <ng-container *ngIf="form.controls.hasSigningAuthority.value">
    <hr class="m-0" />

    <app-international-address-form-grid
      [controlIdPrefix]="controlIdPrefix + 'additionalContactAddress-' + index"
      [form]="form.controls.address"
      [formSubmitted]="formSubmitted" />
  </ng-container>
</div>
